// src/lib/onboarding/defer-onboarding.ts
import { supabase, isSupabaseConfigured } from '@/lib/supabase';
import { reportError } from '@/lib/errors';

/**
 * Sets `profiles.onboarding_deferred = true` (soft-gate) so the `index.tsx` guard
 * (via `shouldEnterApp`) lets the user into the app instead of bouncing them back
 * into onboarding. Shared by every soft-gate exit point (Save & Exit, Skip for now).
 *
 * Best-effort: callers should navigate regardless of the outcome — blocking exit
 * on a DB round-trip is worse than the resume banner not showing until the next
 * successful save. Errors are reported, not swallowed, but never thrown.
 */
export async function deferOnboarding(userId: string | undefined, context: string): Promise<void> {
  if (!isSupabaseConfigured() || !userId) return;
  try {
    const { error } = await supabase
      .from('profiles')
      .update({ onboarding_deferred: true })
      .eq('id', userId);
    if (error) reportError(error, { context, silent: true });
  } catch (err) {
    reportError(err, { context, silent: true });
  }
}
